export function MonitorIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M12.5 14.1667V17.5H7.49996V14.1667M4.33329 14.1667H15.6666C16.6 14.1667 17.0668 14.1667 17.4233 13.985C17.7369 13.8252 17.9918 13.5703 18.1516 13.2567C18.3333 12.9001 18.3333 12.4334 18.3333 11.5V5.16667C18.3333 4.23325 18.3333 3.76654 18.1516 3.41002C17.9918 3.09641 17.7369 2.84144 17.4233 2.68166C17.0668 2.5 16.6 2.5 15.6666 2.5H4.33329C3.39987 2.5 2.93316 2.5 2.57664 2.68166C2.26304 2.84144 2.00807 3.09641 1.84828 3.41002C1.66663 3.76654 1.66663 4.23325 1.66663 5.16667V11.5C1.66663 12.4334 1.66663 12.9001 1.84828 13.2567C2.00807 13.5703 2.26304 13.8252 2.57664 13.985C2.93316 14.1667 3.39987 14.1667 4.33329 14.1667Z" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6.6665 7.66667V11M13.3332 9.16675V11M9.99984 6.00008V11" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

MonitorIcon.displayName = 'MonitorIcon';